// ============================================
// GANTT FILTER HELPER
// ============================================
//
// t17: thin re-export wrapper so the Gantt view uses the same filter
// predicate as Calendar / Kanban (so a task hidden in one view is
// hidden in the others for the same saved view). Mirrors the
// calendar-filters.ts pattern; the underlying implementation is the
// one from calendar-filters so behaviour stays identical.

import type { CustomField, Task, ViewConfig } from '@/lib/schemas';
import { applyCalendarFilters } from '../calendar/calendar-filters';

export function applyGanttFilters(
    tasks: Task[],
    filters: ViewConfig['filters'] | undefined,
    customFields: CustomField[]
): Task[] {
    return applyCalendarFilters(tasks, filters, customFields);
}
